import { useEffect, useState, useRef } from 'react';
import { isEmpty, passwordCheck, sha256 } from '@Views/utils/StringUtils';
import { callService } from '@Views/utils/ServiceUtils';

import Popup from '@Views/comp/Popup';

const PasswordPopup = ({ popupRef, type, svyrEmplySpprrDetail, setPageNo, history }: any) => {

    const win: any = window;

    let [title, setTitle] = useState<any>();
    let [desc, setDesc] = useState<any>();

    const passwordRef: any = useRef();
    const passwordConfirmRef: any = useRef();

    const finalConfirm = () => {

        if (isEmpty(passwordRef['current']['value'])) {
            alert("비밀번호를 입력해주세요.");
            return;
        }

        if (isEmpty(passwordConfirmRef['current']['value'])) {
            alert("비밀번호 확인을 입력해주세요.");
            return;
        }

        if (!passwordCheck(passwordRef['current']['value'])) {
            alert("숫자+영문자+특수문자(#?!@$%^&*-) 조합으로 9자리 이상 사용해야합니다.");
            return;
        }

        if (passwordRef['current']['value'] !== passwordConfirmRef['current']['value']) {
            alert('비밀번호 확인이 같지않습니다.');
            return;
        }

        svyrEmplySpprrDetail['ecryPwd'] = sha256(passwordRef['current']['value']);
        if (type === 'save') {
            svyrEmplySpprrDetail['pcsDvVal'] = '0'
        }
        else if (type === 'submit') {
            svyrEmplySpprrDetail['pcsDvVal'] = '1'
        }

        // 저장호출
        OEMPA04U01();

    }

    const OEMPA04U01 = async () => {

        let res = await callService("OEMPA04U01", svyrEmplySpprrDetail);

        if (!isEmpty(res)) {
            if (type === 'save') {
                popupRef['current'].isOpen(false);
                win.alert("저장이 완료되었습니다.<br/>지원서수정 메뉴로 이동하겠습니다."
                    , async function () {
                        history.push('/Information/EmploymentUpdate');
                    }
                    , async function () {
                        history.push('/Information/EmploymentUpdate');
                    }
                );
            }
            else if (type === 'submit') {
                popupRef['current'].isOpen(false);
                win.alert("제출이 완료되었습니다.<br/>목록으로 이동하겠습니다."
                    , async function () {
                        history.push('/Employment');
                    }
                    , async function () {
                        history.push('/Employment');
                    }
                );
            }

        }

    }

    useEffect(() => {
        passwordRef['current']['value'] = null;
        passwordConfirmRef['current']['value'] = null;

        if (type === 'save') {
            setTitle('지원서 저장');
            setDesc('작성중인 지원서를 저장합니다.<br/>지원서수정 메뉴에서 조회하실 수 있습니다.<br/><strong style="color:#ee4c4c">최종적으로 지원을 완료하신 것은 아닙니다.<br/>수정을 완료한 후 꼭 “제출” 하시기 바랍니다.</strong>');
        }
        else if (type === 'submit') {
            setTitle('지원서 제출');
            setDesc('작성중인 지원서를 제출합니다.<br/><strong style="color:#ee4c4c">제출시 수정이 불가합니다.</strong>');
        }
    }, [type]);

    return <>
        <Popup className="modal-sm change-pw" title={title} ref={popupRef}>
            <div className="modal-body">
                <p className="color-4c84ff" dangerouslySetInnerHTML={{ __html: desc }} />
                {/* <p dangerouslySetInnerHTML={{ __html: desc }} /> */}

                <fieldset>
                    <div className="form-group" style={{ marginBottom: "10px" }}>
                        <div className="input-box-group">
                            <div className="input-box clearfix">
                                <label>비밀번호</label>
                                <div className="input-group">
                                    <input className="form-control" type="password" placeholder="비밀번호를 입력해주세요." ref={passwordRef} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-group" style={{ marginBottom: "10px" }}>
                        <div className="input-box-group">
                            <div className="input-box clearfix">
                                <label>비밀번호 확인</label>
                                <div className="input-group">
                                    <input className="form-control" type="password" placeholder="비밀번호를 한번 더 입력해주세요." ref={passwordConfirmRef} onKeyDown={(e) => { if ((e.code === 'Enter')) { finalConfirm() } }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <p className="input-guide text-important" style={{ padding: "0px" }}>비밀번호 9자 이상 숫자, 영문, 특수문자가 각 하나이상 들어가야 합니다.</p>
                    <div className="btn-group btn-130">
                        <button type="button" className="btn btn-popup positive" onClick={finalConfirm}>확인</button>
                    </div>
                </fieldset>
            </div>
        </Popup>
    </>
}




const EmploymentWrite3 = ({ msg, history, setPageNo, svyrEmplyPbanNo, svyrEmplySpprrDetail }: any) => {

    const adtnInfoCtnt1Ref: any = useRef();
    const adtnInfoCtnt2Ref: any = useRef();

    const passwordPopupRef: any = useRef();
    let [passwordPopupType, setPasswordPopupType] = useState<any>();

    const [adtnInfoCtnt1Size, setAdtnInfoCtnt1Size] = useState<any>(0);
    const [adtnInfoCtnt2Size, setAdtnInfoCtnt2Size] = useState<any>(0);

    const before = () => {

        svyrEmplySpprrDetail['adtnInfoCtnt1'] = adtnInfoCtnt1Ref['current']['value'];
        svyrEmplySpprrDetail['adtnInfoCtnt2'] = adtnInfoCtnt2Ref['current']['value'];

        if (!isEmpty(svyrEmplySpprrDetail['slctInfoUtlzCnsnYn'])) {
            if (svyrEmplySpprrDetail['slctInfoUtlzCnsnYn'] === 'Y') {
                setPageNo(2);
            }
            else if (svyrEmplySpprrDetail['slctInfoUtlzCnsnYn'] === 'N') {
                setPageNo(0);
            }
        }

    }

    const save = () => {

        if (!isEmpty(adtnInfoCtnt1Ref['current']['value'])) {
            if (adtnInfoCtnt1Ref['current']['value'].length > 500) {
                alert("자기소개 내용이 500자 넘었습니다.");
                return;
            }
        }

        if (!isEmpty(adtnInfoCtnt2Ref['current']['value'])) {
            if (adtnInfoCtnt2Ref['current']['value'].length > 500) {
                alert("지원동기 내용이 500자 넘었습니다.");
                return;
            }
        }

        svyrEmplySpprrDetail['adtnInfoCtnt1'] = adtnInfoCtnt1Ref['current']['value'];
        svyrEmplySpprrDetail['adtnInfoCtnt2'] = adtnInfoCtnt2Ref['current']['value'];

        setPasswordPopupType('save');
        passwordPopupRef['current'].isOpen(true);
    }

    const submit = () => {

        if (!isEmpty(adtnInfoCtnt1Ref['current']['value'])) {
            if (adtnInfoCtnt1Ref['current']['value'].length > 500) {
                alert("자기소개 내용이 500자 넘었습니다.");
                return;
            }
        }

        if (!isEmpty(adtnInfoCtnt2Ref['current']['value'])) {
            if (adtnInfoCtnt2Ref['current']['value'].length > 500) {
                alert("지원동기 내용이 500자 넘었습니다.");
                return;
            }
        }

        svyrEmplySpprrDetail['adtnInfoCtnt1'] = adtnInfoCtnt1Ref['current']['value'];
        svyrEmplySpprrDetail['adtnInfoCtnt2'] = adtnInfoCtnt2Ref['current']['value'];

        setPasswordPopupType('submit');
        passwordPopupRef['current'].isOpen(true);
    }

    const onChangeAdtnInfoCtnt1 = () => {
        setAdtnInfoCtnt1Size(adtnInfoCtnt1Ref['current']['value'].length);
    }

    const onChangeAdtnInfoCtnt2 = () => {
        setAdtnInfoCtnt2Size(adtnInfoCtnt2Ref['current']['value'].length);
    }

    useEffect(() => {

        if (!isEmpty(svyrEmplySpprrDetail)) {

            if (!isEmpty(svyrEmplySpprrDetail['adtnInfoCtnt1'])) {
                adtnInfoCtnt1Ref['current']['value'] = svyrEmplySpprrDetail['adtnInfoCtnt1'];
                setAdtnInfoCtnt1Size(adtnInfoCtnt1Ref['current']['value'].length);
            }

            if (!isEmpty(svyrEmplySpprrDetail['adtnInfoCtnt2'])) {
                adtnInfoCtnt2Ref['current']['value'] = svyrEmplySpprrDetail['adtnInfoCtnt2'];
                setAdtnInfoCtnt2Size(adtnInfoCtnt2Ref['current']['value'].length);
            }


        }

    }, [svyrEmplySpprrDetail]);

    return (
        <>
            <PasswordPopup popupRef={passwordPopupRef} type={passwordPopupType} svyrEmplySpprrDetail={svyrEmplySpprrDetail} setPageNo={setPageNo} history={history} />
            <div className="wrap-body-center">
                <div className="bg"></div>
                <div className="join-step" style={{ width: "800px" }}>
                    <div className="join-step-head">
                        <div className="left">
                            <h2>지원서</h2>
                        </div>
                        <div className="right">
                            <div className="step-status">
                                <ul className="clearfix">
                                    <li className="step-li"><span className="num">1</span> <span className="step-txt">작성중</span></li>
                                    <li className="step-li"><span className="num">2</span> <span className="step-txt">작성중</span></li>
                                    <li className="step-li active"><span className="num">3</span> <span className="step-txt">작성중</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="join-step-body">
                        <div>
                            <fieldset>
                                <h3 style={{ display: "flex", justifyContent: "space-between" }}>
                                    <strong>6. 자기소개(간략히 기재-500자 내)</strong>
                                    <strong>({adtnInfoCtnt1Size}자)</strong>
                                </h3>
                                <div className="input-group">
                                    <textarea className="form-control" rows={10} style={{ width: "100%", resize: "none", borderColor: "#dddddd" }} ref={adtnInfoCtnt1Ref} onChange={onChangeAdtnInfoCtnt1}></textarea>
                                </div>

                                <h3 style={{ display: "flex", justifyContent: "space-between" }}>
                                    <strong>7. 지원동기(간략히 기재-500자 내)</strong>
                                    <strong>({adtnInfoCtnt2Size}자)</strong>
                                </h3>
                                <div className="input-group">
                                    <textarea className="form-control" rows={10} style={{ width: "100%", resize: "none", borderColor: "#dddddd" }} ref={adtnInfoCtnt2Ref} onChange={onChangeAdtnInfoCtnt2}></textarea>
                                </div>

                            </fieldset>
                        </div>

                        <div className="btn-group btn-130">
                            <button type="button" className="btn btn-popup negative" onClick={before}>이전</button>
                            <button type="button" className="btn btn-popup positive" onClick={save} style={{ backgroundColor: "#d6eaf1", borderColor: "#d6eaf1", color: "black" }}>저장</button>
                            <button type="button" className="btn btn-popup positive" onClick={submit}>제출</button>
                        </div>
                    </div>

                </div>
            </div>
        </>
    );

}

export default EmploymentWrite3;